import {jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {Exhibit} from "timvir/blocks";
function _createMdxContent(props) {
  return _jsxs(Exhibit, {
    BackdropProps: {
      style: {
        padding: 20,
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "center",
        gap: 20
      }
    },
    children: [_jsx("div", {
      style: {
        background: "#f0f8",
        height: 32,
        width: 120
      }
    }), _jsx("div", {
      style: {
        background: "#f0f8",
        height: 32,
        width: 80
      }
    }), _jsx("div", {
      style: {
        background: "#f0f8",
        height: 32,
        width: 90
      }
    }), _jsx("div", {
      style: {
        background: "#f0f8",
        height: 32,
        width: 160
      }
    }), _jsx("div", {
      style: {
        background: "#f0f8",
        height: 32,
        width: 90
      }
    }), _jsx("div", {
      style: {
        background: "#f0f8",
        height: 32,
        width: 100
      }
    }), _jsx("div", {
      style: {
        background: "#f0f8",
        height: 32,
        width: 140
      }
    }), _jsx("div", {
      style: {
        background: "#f0f8",
        height: 32,
        width: 100
      }
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
